import './styles.scss'
import { useClickAway, useLockBodyScroll } from 'react-use'
import { useRef } from 'react'
import classNames from 'classnames'
export default function Modal(props) {
  const { modal, toggleModal } = props
  const ref = useRef()
  useClickAway(ref, () => {
    toggleModal(null)
  })
  const mobile = window.innerWidth < 768 && 'ontouchstart' in window
  useLockBodyScroll(!mobile)

  return (
    <div className={classNames("Modal", modal.label)}>
      <div className='ModalShade'>
        <div className="modalContent" ref={ref}>
          {modal.component}
          <div className="modalClose" onClick={() => toggleModal(null)}>
            <span>&times;</span> Close
          </div>
        </div>
      </div>
    </div>
  )
}
